import React from 'react';
const benefits = [{
  title: 'Más tranquilidad en casa',
  desc: 'Tener alternativas naturales organizadas para las molestias cotidianas, sin recurrir siempre a lo mismo.'
}, {
  title: 'Soluciones a mano, sin scrollear internet',
  desc: 'Ahorrás tiempo y dejás de buscar información mezclada y poco confiable cada vez que aparece un problema.'
}, {
  title: 'Recuperás conocimientos tradicionales',
  desc: 'Hierbas, infusiones y preparaciones que pasaron de generación en generación, explicadas de forma simple.'
}, {
  title: 'Hábitos más naturales y conscientes',
  desc: 'Pequeños rituales que se suman a tu día y mejoran cómo te sentís en general.'
}, {
  title: 'Ideal para toda la familia',
  desc: 'Recetas pensadas para distintas edades y situaciones cotidianas del hogar.'
}, {
  title: 'Una biblioteca digital siempre disponible',
  desc: 'La consultás desde el celular en cualquier momento, sin internet, sin esperas.'
}];
export function Benefits() {
  return <section className="py-12 md:py-20 px-5 bg-cream-100" data-id="element-17">
      <div className="max-w-4xl mx-auto" data-id="element-18">
        <div className="text-center mb-8 md:mb-12 max-w-2xl mx-auto" data-id="element-19">
          <p className="text-xs uppercase tracking-[0.2em] text-olive-600 font-medium mb-4" data-id="element-20">
            Por qué tenerla
          </p>
          <h2 className="font-serif font-medium text-3xl md:text-4xl text-ink-900 leading-tight" data-id="element-21">
            Lo que esta guía{' '}
            <span className="italic text-olive-600" data-id="element-22">
              cambia en tu día a día
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-5" data-id="element-23">
          {benefits.map((b, idx) => <div key={idx} className="bg-cream-50 border border-cream-300 rounded-2xl p-6" data-id="element-24">
              <div className="flex items-start gap-3 mb-3" data-id="element-25">
                <span className="font-serif text-olive-500 text-sm font-semibold" data-id="element-26">
                  0{idx + 1}
                </span>
                <h3 className="font-serif font-medium text-lg text-ink-900 leading-tight flex-1" data-id="element-27">
                  {b.title}
                </h3>
              </div>
              <p className="text-sm text-ink-700 leading-relaxed pl-7" data-id="element-28">
                {b.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}